import { createSlice } from "@reduxjs/toolkit";
import {
  allUsers,
  createUser,
  deleteUser,
  getUser,
  restorePassword,
  updateSelf,
  updateSubscriptions,
} from "./user.action";
import { IUserState } from "./types/userState.interface";

const initialState: IUserState = {
  ui: { loading: false, userInfo: null, allUsers: null },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUser.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.userInfo = action.payload;
      })
      .addCase(getUser.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(getUser.rejected, (state) => {
        state.ui.loading = false;
        state.ui.userInfoError = "Error fetching user info";
      })
      .addCase(allUsers.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.allUsers = action.payload;
      })
      .addCase(allUsers.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(allUsers.rejected, (state) => {
        state.ui.loading = false;
        state.ui.allUsersError = "Error fetching all users";
      })
      .addCase(updateSelf.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.updateSelfMessage = action.payload;
      })
      .addCase(updateSelf.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(updateSelf.rejected, (state) => {
        state.ui.loading = false;
        state.ui.updateSelfMessage = "Error updating user";
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.createUserMessage = action.payload;
      })
      .addCase(createUser.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(createUser.rejected, (state) => {
        state.ui.loading = false;
        state.ui.createUserMessage = "Error creating user";
      })
      .addCase(updateSubscriptions.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.updateSubscriptionsMessage = action.payload;
      })
      .addCase(updateSubscriptions.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(updateSubscriptions.rejected, (state) => {
        state.ui.loading = false;
        state.ui.updateSubscriptionsMessage = "Error updating subscriptions";
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.deleteUserMessage = action.payload;
      })
      .addCase(deleteUser.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(deleteUser.rejected, (state) => {
        state.ui.loading = false;
        state.ui.deleteUserMessage = "Error deleting user";
      })
      .addCase(restorePassword.pending, (state) => {
        state.ui.loading = true;
      })
      .addCase(restorePassword.fulfilled, (state, action) => {
        state.ui.loading = false;
        state.ui.restorePasswordMessage = action.payload.message;
      })
      .addCase(restorePassword.rejected, (state) => {
        state.ui.loading = false;
      });
  },
});
